const ENV = process.env.REACT_APP_ENV;

if (!ENV && process.env.NODE_ENV === "production") {
    throw new Error("Missing REACT_APP_ENV. Use `npm run build:local` or `npm run build:prod`.");
}

export const LOCAL_MODE = process.env.REACT_APP_LOCAL_MODE === "true";
export const SKIP_ONBOARDING = process.env.REACT_APP_SKIP_ONBOARDING === "true";
export const SHOW_DIGEST_FLOW = process.env.REACT_APP_SHOW_DIGEST_FLOW === "true";
export const SKIP_DATA_SYNC = process.env.REACT_APP_SKIP_DATA_SYNC === "true";
export const SHOW_DATA_LOADING_SCREEN = process.env.REACT_APP_SHOW_DATA_LOADING_SCREEN === "true";
export const SHOW_SPLASH_SCREEN = process.env.REACT_APP_SHOW_SPLASH_SCREEN === "true";
export const SHOW_LOGIN_SCREEN = process.env.REACT_APP_SHOW_LOGIN_SCREEN === "true";
export const USE_CREATE_SUGGESTION = process.env.REACT_APP_USE_CREATE_SUGGESTION === "true";
export const PREVIEW_MODE = process.env.REACT_APP_PREVIEW_MODE === "true";
export const MOCK_ASSISTANT_MODE = process.env.REACT_APP_MOCK_ASSISTANT === "true";
export const MOCK_TIME_ASSISTANT_MODE = process.env.REACT_APP_MOCK_TIME_ASSISTANT === "true";